module.exports = __webpack_public_path__ + "static/media/9. Tres de tres, Óleo sobre resina cristal, 70 x 130 cm, 2020 copy.331e5253.png";